// extracted by mini-css-extract-plugin
export default {"dropdownItem":"SmallDropdownItem_dropdownItem__izhGx"};